<template>
  <div>
    <b-table
      :striped="false"
      :bordered="false"
      :borderless="false"
      :outlined="false"
      :small="false"
      :dark="false"
      :fixed="false"
      :foot-clone="false"
      :no-border-collapse="false"
      :items="items"
      :fields="fields"
      :head-variant="''"
      :busy="isBusy"
      :table-variant="''"
    >
      <template #cell(fullName)="data">
        <span class="expire">{{ data.item.fullName }}</span>
      </template>
      <template #cell(createdDate)="data">
        <span class="expire">{{ data.item.createdDate }}</span>
      </template>
      <template #cell(description)="data">
        <span class="expire">{{ data.item.description }}</span>
      </template>
      <template #table-busy>
        <div class="text-center text-primary my-2">
          <b-spinner class="align-middle"></b-spinner>
        </div>
      </template>
      <template #cell(image)="data">
        <img v-if="!data.item.image" src="@/assets/images/users/default.png" alt="avatar" class="userImg" />
        <img v-else :src="data.item.image" alt="" class="userImg" />
      </template>
      <template #cell(score)="data">
        <b-form-rating
          v-model="data.item.score"
          @change="updateScore(data.item.id, data.item.score)"
          no-border
          variant="warning"
          style="cursor: pointer; direction: rtl"
        ></b-form-rating>
      </template>
      <template #cell(url)="data">
        <div @click="downloadHandle(data.item.url, data.item.urlType)" target="_blank" download>
          <i class="fa-regular fa-file-lines"></i>
        </div>
      </template>
    </b-table>
    <div style="text-align: center" v-if="items.length === 0 && !isBusy">هیچ عضوی برای این تمرین وجود ندارد !</div>
  </div>
</template>

<script>
import axios from 'axios'
import dadbanCourseProvider from '../../../services/dadban/course'
import moment from 'jalali-moment'
export default {
  props: {},
  data() {
    return {
      fields: [
        { key: 'image', label: '#' },
        { key: 'fullName', label: 'نام و نام خانوادگی' },
        { key: 'createdDate', label: 'تاریخ ارسال' },
        { key: 'description', label: 'توضیحات' },
        { key: 'url', label: 'نتیجه' },
        { key: 'score', label: 'نمره' },
      ],
      items: [],
      isBusy: false,
    }
  },
  mounted() {
    this.fetchUsers()
  },
  methods: {
    async fetchUsers() {
      this.isBusy = true
      const req = await dadbanCourseProvider.getTrainUsers(+this.$route.query.fileId)
      req.data.data.output.forEach((item) => {
        this.items.push({
          image: item.image,
          fullName: item.fullName,
          createdDate: moment(item.createdDate).locale('fa').format('YYYY/MM/DD - hh:mm'),
          description: item.description,
          url: item.url,
          score: item.score === null ? 0 : item.score,
          id: item.id,
        })
      })
      this.isBusy = false
    },
    async updateScore(id, score) {
      const body = { id: +id, score: score }
      await dadbanCourseProvider.updateUserTrainScore(body)
    },
    async downloadHandle(link, type) {
      await axios
        .get(link, {
          responseType: 'arraybuffer',
        })
        .then((response) => {
          const blob = new Blob([response.data], { type: type || 'application/msword' })
          const url = window.URL.createObjectURL(blob)
          const link = document.createElement('a')
          link.href = url
          link.download = 'userResult' + (type === 'application/msword' ? '.docx' : type === 'application/pdf' ? '.pdf' : '.docx')
          document.body.appendChild(link)

          link.dispatchEvent(
            new MouseEvent('click', {
              bubbles: true,
              cancelable: true,
              view: window,
            }),
          )

          URL.revokeObjectURL(url)
          document.body.removeChild(link)
        })
    },
  },
}
</script>

<style lang="scss" scoped>
.fa-file-lines {
  font-size: 18px;
  color: #000;
  cursor: pointer;
  &:hover {
    color: #556ee6;
  }
}

.userImg {
  width: 32px;
  height: 32px;
  border-radius: 100%;
  object-fit: cover;
}

// .expire {
//   color: #f46a6a;
// }
</style>
